module.exports = __webpack_public_path__ + "img/PDM_logo_no_text.57c1e889.svg";